import React, { createContext, useContext, useEffect, useState } from 'react';
import { DEFAULT_DARK_THEME, DEFAULT_LIGHT_THEME, isThemeName, modeOf, THEME_OPTIONS } from '../utilities/themeOptions';

const ThemeContext = createContext();

const THEME_STORAGE_KEY = 'library_theme';

const resolveInitialTheme = () => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (isThemeName(stored)) return stored;

  if (window.matchMedia?.('(prefers-color-scheme: light)').matches) {
    return DEFAULT_LIGHT_THEME;
  }

  return DEFAULT_DARK_THEME;
};

const applyTheme = (name) => {
  document.documentElement.dataset.theme = name;
  document.documentElement.dataset.mode = modeOf(name);
  document.documentElement.style.colorScheme = modeOf(name);
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(DEFAULT_DARK_THEME);

  useEffect(() => {
    const initial = resolveInitialTheme();
    setThemeState(initial);
    applyTheme(initial);
  }, []);

  const setTheme = (name) => {
    if (!isThemeName(name)) return;
    setThemeState(name);
    localStorage.setItem(THEME_STORAGE_KEY, name);
    applyTheme(name);
  };

  const mode = modeOf(theme);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, mode, themeOptions: THEME_OPTIONS }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
